var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-address",
      class: [_vm.isLastUsed ? "global-address--last-used" : ""],
    },
    [
      _c("div", { staticClass: "global-address__content" }, [
        _vm.isLastUsed
          ? _c("small", { staticClass: "global-address__last-used" }, [
              _vm._v(_vm._s(_vm.$t("labels.lastUsed"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("address", [
          _vm.company
            ? _c("p", { staticClass: "global-address__company" }, [
                _c("strong", [_vm._v(_vm._s(_vm.company))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.user
            ? _c("p", { staticClass: "global-address__user" }, [
                _vm._v(_vm._s(_vm.user)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.street
            ? _c("p", { staticClass: "global-address__street" }, [
                _vm._v(_vm._s(_vm.street)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.zipCity
            ? _c("p", { staticClass: "global-address__zip-city" }, [
                _vm._v(_vm._s(_vm.zipCity)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.country
            ? _c("p", { staticClass: "global-address__country" }, [
                _vm._v(_vm._s(_vm.country)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.phone
            ? _c("p", { staticClass: "global-address__phone" }, [
                _vm._v(_vm._s(_vm.phone)),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "global-address__side-actions" },
        [_vm._t("side-actions")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "global-address__actions" }, [
        _c(
          "div",
          { staticClass: "button-wrapper spaced left spacer--top" },
          [_vm._t("actions")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }